/**
 * Tipos para la configuración que comparte el dashboard con la app móvil.
 * Firestore: colección adminSettings, documento "main".
 * La app móvil (admin) edita: Tienda, Horarios, Financiamiento, Legal, Notificaciones, Redes sociales.
 */

export interface DayHours {
  open: string;
  close: string;
  closed: boolean;
}

export interface BusinessHours {
  monday: DayHours;
  tuesday: DayHours;
  wednesday: DayHours;
  thursday: DayHours;
  friday: DayHours;
  saturday: DayHours;
  sunday: DayHours;
}

export interface StoreSettings {
  storeName: string;
  storePhone: string;
  storeEmail: string;
  storeAddress?: string;
  storeCity?: string;
  location?: {
    latitude?: number;
    longitude?: number;
  };
  businessHours: BusinessHours;
}

export interface FiscalSettings {
  rnc: string;
  companyName?: string;
  companyAddress?: string;
}

export interface NotificationSettings {
  emailNotifications: boolean;
  whatsappNotifications: boolean;
  pushNotifications: boolean;
  smsNotifications?: boolean;
}

export interface SocialMediaSettings {
  facebook?: string;
  instagram?: string;
  whatsapp?: string;
  twitter?: string;
  youtube?: string;
}

/** Campos de financiamiento que edita la pantalla de configuración (app móvil y dashboard). */
export interface FinancingSettingsForm {
  isEnabled: boolean;
  requiresApproval: boolean;
  maxFinancingAmount: number;
  minCreditScore?: number;
  baseInterestRate?: number;
}

/** Configuración del módulo de garantías (dashboard y app). */
export interface WarrantySettings {
  moduleEnabled: boolean;
  defaultWarrantyText: string;
  warrantyContactEmail: string;
  warrantyContactPhone: string;
}

/** Documento principal de admin settings en Firestore (solo las partes que usamos). */
export interface AdminSettingsDoc {
  id?: string;
  store: StoreSettings;
  fiscal: FiscalSettings;
  notifications: NotificationSettings;
  socialMedia: SocialMediaSettings;
  financing: FinancingSettingsForm & Record<string, unknown>;
  warranty?: WarrantySettings;
  [key: string]: unknown;
}

export const DEFAULT_BUSINESS_HOURS: BusinessHours = {
  monday: { open: "09:00", close: "18:00", closed: false },
  tuesday: { open: "09:00", close: "18:00", closed: false },
  wednesday: { open: "09:00", close: "18:00", closed: false },
  thursday: { open: "09:00", close: "18:00", closed: false },
  friday: { open: "09:00", close: "18:00", closed: false },
  saturday: { open: "09:00", close: "17:00", closed: false },
  sunday: { open: "10:00", close: "16:00", closed: false },
};

export const DAY_LABELS: Record<keyof BusinessHours, string> = {
  monday: "Lunes",
  tuesday: "Martes",
  wednesday: "Miércoles",
  thursday: "Jueves",
  friday: "Viernes",
  saturday: "Sábado",
  sunday: "Domingo",
};
